<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2>Actualizar Contraseña</h2>
    </v-card-title>
    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation class="mx-10">
      <v-card flat>
        <v-toolbar color="grey" dark dense flat>
          <h3>
            {{ currentUser.name.toUpperCase() }}
            <span v-if="currentUser.sala_data != null">- {{ currentUser.sala_data.nombre.toUpperCase() }}</span>
          </h3>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                :value="currentUser.email"
                label="Email"
                prepend-icon="mdi-email"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="changePassword"
                label="Cambiar Contraseña"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="changePassword">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pass.currentPassword"
                :append-icon="showcurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Contraseña Actual"
                :type="showcurrentPassword ? 'text' : 'password'"
                counter
                @click:append="showcurrentPassword = !showcurrentPassword"
                :rules="notBlankRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pass.newPassword"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="notBlankRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="pass.newPassword_confirmation"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Confirmar Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="notBlankRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!valid"
                  color="#616161"
                  class="white--text"
                  @click="cambiarPassword()">
                  Actualizar Contraseña
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');

  export default {
    data: () => ({
      valid: true,
      changePassword:false,
      currentPassword: false,
      pass:{
        currentPassword:'',
        newPassword:'',
        newPassword_confirmation:'',
      },
      defaultData:{
        currentPassword:'',
        newPassword:'',
        newPassword_confirmation:'',
      },
      showcurrentPassword: '',
      shownewPassword: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
    },
    computed: {
      ...mapGetters(["currentUser", "isLoggedIn"])
    },
    methods: {
      cambiarPassword() {
        if (this.isLoggedIn && this.$refs.form.validate()) {
          this.$store.dispatch("ACTUALIZAR_PASSWORD", { url: "/user/updatePassword",
            data: {  savePassword: this.pass  }
          }).then((response) => {
            if(response.data.status == 'ok'){
              Swal.fire({
                icon: 'success',
                title: 'Contraseña actualizada correctamente',
                confirmButtonText: "Aceptar"
              })
              this.reset();
            }
            if(response.data.status == 'notmatch'){
              Swal.fire({
                icon: 'error',
                title: 'La contraseña actual no coincide',
                confirmButtonText: "Aceptar"
              })
            }

          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'La nueva contraseña no coincide',
              icon: "error",
              confirmButtonText: "Aceptar"
            })
          });
        }
      },
      reset() {
        this.pass = Object.assign({}, this.defaultData)
        this.changePassword=false
      },
    }
  };
</script>
